/**
 * Maps FlowchartView props onto the handler bag consumed by prop builders.
 * Delete handlers are the bridge-prompt wrappers, not the raw props.
 */
export function buildFlowchartHandlers(props, bridge) {
  return {
    onNavigateToParent: props.onNavigateToParent,
    onSelectSprint: props.onSelectSprint,
    onStatusChange: props.onStatusChange,
    onDecisionAnswerChange: props.onDecisionAnswerChange,
    onDecisionOptionsChange: props.onDecisionOptionsChange,
    onDependencyChange: props.onDependencyChange,
    onConditionsChange: props.onConditionsChange,
    onMilestoneAnchorChange: props.onMilestoneAnchorChange,
    onAddMilestoneOnHost: props.onAddMilestoneOnHost,
    onAddNoteOnHost: props.onAddNoteOnHost,
    onCreateParallelMission: props.onCreateParallelMission,
    onInsertMissionBefore: props.onInsertMissionBefore,
    onDeleteTask: bridge.handleDeleteTaskWithBridgeCheck,
    onDeleteTasks: bridge.handleDeleteTasksWithBridgeCheck,
    onCreateConnectedTask: props.onCreateConnectedTask,
    onRenameTask: props.onRenameTask,
    onCategoryChange: props.onCategoryChange,
    onAddTag: props.onAddTag,
    onRemoveTag: props.onRemoveTag,
    onSetPrimaryTag: props.onSetPrimaryTag,
    onIconChange: props.onIconChange,
    onIconDeleted: props.onIconDeleted,
    onTaskResize: props.onTaskResize,
    onTaskResizeEnd: props.onTaskResizeEnd,
    onTaskResetSize: props.onTaskResetSize,
    onPositionChange: props.onPositionChange,
    onPositionChangeBatch: props.onPositionChangeBatch,
    onFocusModeChange: props.onFocusModeChange,
    onOpenNestedSprint: props.onOpenNestedSprint,
    onCreateNestedSprint: props.onCreateNestedSprint,
    onRemoveNestedSprint: props.onRemoveNestedSprint,
    onNestTasks: props.onNestTasks,
    onPasteTasks: props.onPasteTasks,
    onAddTask: props.onAddTask,
    onDeliverablesChange: props.onDeliverablesChange,
    onInputsChange: props.onInputsChange,
    onAddStatus: props.onAddStatus,
    onDeleteStatus: props.onDeleteStatus,
    onRenameStatus: props.onRenameStatus,
    onSetStatusAutoSync: props.onSetStatusAutoSync,
    onRenameCategory: props.onRenameCategory,
    onDeleteCategory: props.onDeleteCategory,
    onRenameTag: props.onRenameTag,
    onDeleteTag: props.onDeleteTag,
    onDueDateChange: props.onDueDateChange,
    onRemindersChange: props.onRemindersChange,
    onEstimatedDurationMinutesChange: props.onEstimatedDurationMinutesChange,
    onCreatedAtChange: props.onCreatedAtChange,
    onStartedAtChange: props.onStartedAtChange,
    onCompletedAtChange: props.onCompletedAtChange,
    onUpdatedAtChange: props.onUpdatedAtChange,
    onPriorityChange: props.onPriorityChange,
    onDifficultyChange: props.onDifficultyChange,
    onCustomFieldValueChange: props.onCustomFieldValueChange,
    onArchiveTask: props.onArchiveTask,
    onArchiveTasks: props.onArchiveTasks,
    onUnarchiveTask: props.onUnarchiveTask,
    onRenameSprint: props.onRenameSprint,
    onSprintIconChange: props.onSprintIconChange,
    onInsertNodeOnEdge: props.onInsertNodeOnEdge,
    onInsertMilestoneOnEdge: props.onInsertMilestoneOnEdge,
    onOpenDetails: props.onOpenDetails,
    onOpenAttachments: props.onOpenAttachments,
    onNestCampaign: props.onNestCampaign,
    onCompileMissionsIntoNestedCampaign: props.onCompileMissionsIntoNestedCampaign,
    onExplodeNestedCampaign: props.onExplodeNestedCampaign,
    onViewRename: props.onViewRename,
    onViewIconChange: props.onViewIconChange,
    onFlowViewVisibilityChange: props.onFlowViewVisibilityChange,
    onHideViewExplainerModalChange: props.onHideViewExplainerModalChange,
    onChainMoveLeft: props.onChainMoveLeft,
    onChainMoveRight: props.onChainMoveRight,
    onViewChange: props.onViewChange,
    onSelectCustomView: props.onSelectCustomView,
    onGoToTaskInView: props.onGoToTaskInView,
    onShowAddMissionArrow: props.onShowAddMissionArrow,
    onRemoveCampaign: props.onRemoveCampaign,
    onAddCampaignToView: props.onAddCampaignToView,
    openCampaignPickerForPaste: props.openCampaignPickerForPaste,
    onSubmitDeliverable: props.onSubmitDeliverable,
    onEditDeliverables: props.onEditDeliverables,
    onClearDeliverable: props.onClearDeliverable,
  };
}
